module.exports = __webpack_public_path__ + "static/media/twitter.3ddf36b5.svg";